package meineglasfaser.api

enum class InvoiceDeliveryMode {
    EMAIL,
    POSTAL;
}

enum class InvoicePaymentMode {
    EZ,
    SZ;
}
